import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createBlock(_component_Multiselect, {
    searchable: true,
    mode: "tags",
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
    options: _ctx.options,
    placeholder: "Velg kategorier",
    label: "title",
    valueProp: "id",
    class: "bg-white dark:bg-opacity-5",
    noResultsText: "Ingen treff",
    noOptionsText: "Ingen kategorier å vise"
  }, null, 8, ["modelValue", "options"]))
}